import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { StyledPropertyCardPhotoFooter } from './PropertyCardPhotoFooter.styles';

/**
 * A container that appears at the bottom of a property photo in a `PropertyCard`.
 * Usually contains a `PropertyCard.MLSLogo`.
 *
 * @since 8.63.0
 */
export var PropertyCardPhotoFooter = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledPropertyCardPhotoFooter, _extends({
    ref: forwardedRef
  }, props));
});
PropertyCardPhotoFooter.displayName = 'PropertyCard.PhotoFooter';